import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b866c9e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-board-view" }
const _hoisted_2 = { class: "task-board" }
const _hoisted_3 = {
  class: "task-columns",
  group: "task-columns"
}
const _hoisted_4 = { class: "column-header" }
const _hoisted_5 = { class: "column-title" }
const _hoisted_6 = { class: "column-count" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building me-2" }, null, -1))
const _hoisted_9 = { class: "company-name" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "role-title" }

import { ApplicationApiService } from "@/services/ApplicationApiService";
import { ApplicationStatus } from "@models/SystemEnums";
import { UserApplicationListItem } from "@models/dtos/UserApplicationList";
import { onMounted, ref } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import store from "../store";

interface Card {
  title: string;
  companyName: string;
  applicationId: string;
}

interface Column {
  title: string;
  cards: Card[];
  applicationStatus: ApplicationStatus;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskBoard',
  setup(__props) {

const taskColumns = ref<Column[]>([
  {
    title: "To Apply",
    cards: [],
    applicationStatus: ApplicationStatus.TO_APPLY,
  },
  {
    title: "Applied",
    cards: [],
    applicationStatus: ApplicationStatus.APPLIED,
  },
  {
    title: "Interviewing",
    cards: [],
    applicationStatus: ApplicationStatus.INTERVIEWING,
  },
  {
    title: "Rejected",
    cards: [],
    applicationStatus: ApplicationStatus.REJECTED,
  },
  {
    title: "Offer",
    cards: [],
    applicationStatus: ApplicationStatus.OFFERED,
  },
]);

const applicationsList = ref([] as UserApplicationListItem[]);

onMounted(async () => {
  store.dispatch("toggleLoader", true);
  await loadUserApplications();
  store.dispatch("toggleLoader", false);
});

async function loadUserApplications() {
  // Fetch applications
  const response = await ApplicationApiService.getUserApplicationList();
  if (response.status !== 200) {
    console.error("Problem loading user applications");
    return;
  }

  applicationsList.value = response.data.applications;

  // Populate and sort the cards for each column
  taskColumns.value.forEach((column) => {
    const filteredApps = applicationsList.value.filter(
      (app) => app?.applicationStatus === column.applicationStatus
    );

    if (column.applicationStatus === ApplicationStatus.TO_APPLY) {
      const unassignedApps = applicationsList.value.filter((app) => app?.applicationStatus == null);
      unassignedApps.forEach((app) => {
        filteredApps.push(app);
      });
    }

    // Sort the applications by their index property
    filteredApps.sort((a, b) => a.index - b.index);

    // Map the sorted applications to cards
    column.cards = filteredApps.map((app) => ({
      title: app.roleTitle,
      companyName: app.companyName,
      applicationId: app.applicationId,
    }));
  });
}

async function updateApplicationStatus(event: any) {
  const newColumnIndex = parseInt(event.to.getAttribute("data-column-index"));
  const oldColumnIndex = parseInt(event.from.getAttribute("data-column-index"));
  const newColumn = taskColumns.value[newColumnIndex];
  const columnStatus = newColumn.applicationStatus;
  const movedCard = newColumn.cards[event.newIndex];

  if (event.newIndex === event.oldIndex && newColumnIndex === oldColumnIndex) return;
  try {
    const response = await ApplicationApiService.updateApplicationStatus(
      movedCard.applicationId,
      columnStatus,
      event.newIndex
    );

    if (response.status !== 200) {
      throw new Error("Problem updating application status");
    }

    if (event.oldIndex !== event.newIndex) {
      // If needed, update cards below the one moved
      for (let index = event.newIndex; index < newColumn.cards.length; index++) {
        const card = newColumn.cards[index];
        if (card === movedCard) continue;

        const response = await ApplicationApiService.updateApplicationStatus(
          card.applicationId,
          columnStatus,
          index
        );

        if (response.status !== 200) {
          throw new Error("Problem updating application status for other cards");
        }
      }
    }
  } catch (error) {
    console.error(error);
    // Handle rollback or UI update
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskColumns.value, (column, columnIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["board-column", { 'ms-3': columnIndex === 0 }]),
            key: columnIndex
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(column.title), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(column.cards.length), 1)
            ]),
            _createVNode(_unref(VueDraggableNext), {
              class: "board-card-list",
              modelValue: column.cards,
              "onUpdate:modelValue": ($event: any) => ((column.cards) = $event),
              group: "task-cards",
              onEnd: updateApplicationStatus,
              "data-column-index": columnIndex
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.cards, (card, cardIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "board-card",
                    key: cardIndex
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, _toDisplayString(card.companyName), 1)
                    ]),
                    _createVNode(_component_router_link, {
                      to: {
                  name: 'Application',
                  params: { id: card.applicationId },
                },
                      class: "card-link"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(card.title), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "data-column-index"])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})